import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-progress-bar-calidad',
  templateUrl: './progress-bar-calidad.component.html',
  styleUrls: ['./progress-bar-calidad.component.scss']
})
export class ProgressBarCalidadComponent {
  @Input() data: any;  
     @Input() tipo_error: any;  
  
     @Output() actionCalidad = new EventEmitter<void>();
     @Input() isSelected: boolean = false;
  
      
        chartData:any;
      
        colorsSize:any = {
          'dañado': { color:'#d41d43'},
          'faltante': { color:'#0b817e'},
          'sku incorrecto': { color:'#6bc49a'},
          'sobrante': { color:'#368ccb'},
        };
      
        constructor(
        ) { }
      
        ngOnInit(): void {
          this.chartData = this.barChartProgress(this.data);
        }
      
        barChartProgress = (data:any) => {
          return (
            {
              chart: {
                height: 55,
                type: "bar",
                stacked: true,
                sparkline: {
                  enabled: true,
                },
                events: {
                  dataPointSelection: (event: any, chartContext: any, config: any) => {
                    this.actionCalidad.emit();
                  }
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  barHeight: "30%",
                  colors: {
                      backgroundBarColors: ["#bbb"],
                      backgroundBarOpacity: 0.2,
                  },
                },
              },
              colors: [this.getColorForSize(this.tipo_error)],
              stroke: {
                width: 0,
              },
              fill: {
                colors: [this.getColorForSize(this.tipo_error)],
              },
              series: [
                {
                  data: [data],
                },
              ],
              tooltip: {
                enabled: false,
              },
              xaxis: {
                categories: ["Packed"],
              },
              yaxis: {
                max: 100,
                min: 0,
              },
              responsive: [
                {
                  breakpoint: 767,
                  options: {
                    title: {
                      style: {
                        fontSize: "16px",
                      },
                    },
                  },
                },
              ]
            }
          )
        }
  
        getColorForSize(size: string): string {
          if(size != null){
            size = size.toLowerCase();
            for (let key in this.colorsSize) {
              if (size.includes(key)) {
                return this.colorsSize[key].color;
              }
            }
          }
          return '#000000';
        }
}
